import { render, staticRenderFns } from "./viewSnakeBite.vue?vue&type=template&id=35a59e52"
import script from "./viewSnakeBite.vue?vue&type=script&lang=js"
export * from "./viewSnakeBite.vue?vue&type=script&lang=js"
import style0 from "./viewSnakeBite.vue?vue&type=style&index=0&id=35a59e52&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports